import ActivityListing from "@/Component/Module/ActivityListing";
import SeoHead from "@/Component/Seo/SeoHead";
import { serverFetchActivityListPageHeading } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { normalizeListPageHeading } from "@/utils/homePageHelpers";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function ActivityListPage({
  seo,
  seoCountry,
  initialListPageHeading,
}) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Activities | Next Holidays"
      />
      <ActivityListing initialListPageHeading={initialListPageHeading} />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const listPageHeading = await serverFetchActivityListPageHeading(country);

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialListPageHeading: normalizeListPageHeading(listPageHeading),
      },
    };
  } catch (error) {
    console.error("Activity list page SSR error:", error);
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialListPageHeading: null,
      },
    };
  }
}
